module.exports = __webpack_public_path__ + "images/structure_fig3_250e3ef.jpg";